import React from 'react';
import cs from 'classnames'
import css from './index.css';

export default class Swiper extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      curIndex:0,
      leftpoint:0,
      rightpoint:0,
    }
  }
  componentDidMount() {
    
    this.setState({
      curIndex:0,
      leftpoint:0,
      rightpoint:12,
    })
  }
  turnDir = (dir) =>{
    const {curIndex} = this.state;
    const {photos} = this.props;
    let newIndex = 0 ;
    if ((curIndex === 0 && dir < 0) || (curIndex === photos.length-1 && dir > 0)) {
      newIndex = curIndex;
    }else {
      newIndex = curIndex + dir;
    }
    this.setState({
      curIndex: newIndex
    })
    this.turn(newIndex)
    this.turnBar(newIndex);
  }
  turnTo = (index) => {
    this.setState({
      curIndex: index
    })
    this.turn(index)
    this.turnBar(newIndex);
  }
  turnBarDir = (dir) => {
    this.turnDir(dir);
  }
  turn = (index) => {
    this.refs.photo.style.left = index * 800 * -1 + 'px'
  }
  turnBar = (index) => {
    if(index<=this.state.leftpoint) {
      this.refs.photolist.style.left = index * 70 * -1 + 'px',
      this.setState({
        leftpoint: this.state.leftpoint - 1,
        rightpoint: this.state.rightpoint - 1,
      })
    }
    if(index>=this.state.rightpoint) {
      this.refs.photolist.style.left = (index-11) * 70 * -1 + 'px',
      this.setState({
        leftpoint: this.state.leftpoint + 1,
        rightpoint: this.state.rightpoint + 1,
      })
    }
  }
  renderPhoto(){
    const {photos} = this.props;
    return (
      <div className={css.photoBox}>
        <div ref="photo" style={{position:'absolute',height:'100%',width:"100%"}}>
          <div className = {css.photoTrain}>
            {photos.map((e,i)=>{
              return (
                <div className={cs(css.photo)} style={{backgroundImage:`url(${e})`}} data-id={i}></div>
              )
            })}
          </div>
        </div>
        {
          photos.length !== 1
          ?<div 
            className={cs(css.slideButton,css.leftSide)}
            onClick = {()=>this.turnDir(-1)}
          ></div>
          :null
        }
        {
          photos.length !== 1
          ?<div 
            className={cs(css.slideButton,css.rightSide)}
            onClick = {()=>this.turnDir(1)}
          ></div>
          :null
        }
        <a 
          className={css.download}
          href={photos[this.state.curIndex]}
          download={'bol.jpg'}
        ></a>
      </div>
    )
  }
  renderPhotoList() {
    const {photos} = this.props;
    if(photos.length === 1) return null;
    return (
      <div className={css.photoBar}>
        <div ref="photolist" style={{position:'absolute',height:'100%',width:"100%"}}>
          <div className={css.photoTrain}>
            {photos.map((e,i)=>{
              return (
                <div 
                  className={cs(css.miniPhoto,i===this.state.curIndex&&css.highlight)}
                  style={{backgroundImage:`url(${e})`}}
                  onClick = {()=>this.turnTo(i)}
                ></div>
              )
            })}
          </div>
        </div>
        
        <div 
          className={cs(css.slidebarButton,css.leftbarSide)}
          onClick = {()=>this.turnBarDir(-1)}
        ></div>
        <div 
          className={cs(css.slidebarButton,css.rightbarSide)}
          onClick = {()=>this.turnBarDir(1)}
        ></div>
      </div>
    )
  }
  render(){
    const {photos} = this.props;
    if(!photos) {
      return (
        <div>
          Loading
        </div>
      )
    }
    return (
      <div>
        
        {this.renderPhoto()}
        {this.renderPhotoList()}
      </div>
    )
  }
}


// WEBPACK FOOTER //
// ./src/pages/MessagePush/compontents/MessagePanel/compontents/Swiper/index.js